import { render, staticRenderFns } from "./NecesseretyLabelWithTooltip.vue?vue&type=template&id=484aa510&scoped=true&"
import script from "./NecesseretyLabelWithTooltip.vue?vue&type=script&lang=js&"
export * from "./NecesseretyLabelWithTooltip.vue?vue&type=script&lang=js&"
import style0 from "./NecesseretyLabelWithTooltip.vue?vue&type=style&index=0&id=484aa510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484aa510",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
